import React from 'react'
import { Divider } from 'semantic-ui-react'
// Local
import EncounterPatient from '../common/encounterPatient'
import EncounterProfile from '../common/encounterProfile'
import { PatientType } from '../../authenticated/types'
import { shouldRenderReskin2025 } from '../../../constant'
import If from '../../common/if'

type Props = {
  encounterDetail: PatientType
}

/**
 * Provides a component that renders the Patient Snapshot encounter left content
 * @param encounterDetail Encounter detail entity
 */
function PatientSnapshotEncounterLeft(
  props: Props
): JSX.Element {
  const { encounterDetail } = props
  return (
    <div>
      <Divider className="green-border" />
      <EncounterProfile
        mode="left"
        encounter={ encounterDetail.encounter }
      />
      <If isTrue={ shouldRenderReskin2025 }>
        <div className="profile-divider" />
      </If>
      <EncounterPatient
        mode="left"
        encounter={ encounterDetail.encounter }
        displayName={ true }
        displayBirthDate={ true }
      />
    </div>
  )
}

export default PatientSnapshotEncounterLeft
